export const RCS_TEMPLATE_EDITOR_THEME_STORAGE_ID = 'rcsTemplateEditorTheme';

export const RCS_EDITOR_SPLIT_CONTAINER_CSS_ID = 'rcs-template-editor-split-container';
export const RCS_EDITOR_DEFAULT_PERCENTAGE = 50;

export const rcsEditorThemes = [
  { id: 'light', labelKey: 'designs:rcsTemplateEditor.theme.light' },
  { id: 'dark', labelKey: 'designs:rcsTemplateEditor.theme.dark' },
];
